import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';

import { AppState } from '../../models/communication/app-state.model';

/**
 * Facilitates development by showing (toggling)
 * the current app state by pressing `toggleKey`.
 */
@Component({
    selector: 'app-dev',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './dev.component.html',
    styleUrl: './dev.component.scss'
})
export class DevComponent implements OnInit {
    @Input()
    state?: AppState;

    @Input()
    toggleKey?: string;

    protected demoModeEnabled = false;

    ngOnInit(): void {
        this.initDemoModeKeyboardControl(this.toggleKey ?? 'd');
    }

    private initDemoModeKeyboardControl(toggleKey: string): void {
        fromEvent(window, 'keydown').subscribe((event) => {
            if ((event as KeyboardEvent).key === toggleKey) {
                this.demoModeEnabled = !this.demoModeEnabled;
            }
        });
    }
}
